import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal, Button } from "react-bootstrap";

import * as actions from "../../../../../redux/collaborators/actions";
import { getActiveProject } from "../../../../../redux/projects";
import { inviteCollaborator } from "../../../../../redux/collaborators";

import type CollaboratorCollection from "../../models/CollaboratorCollection";
import type Collaborator from "../../models/Collaborator";
import type User from "../../models/User";
import type Project from "../../models/Project";

import CollaboratorForm from "../../../../../components/forms/collaborator-form/CollaboratorForm";

type Props = {
  user: ?User,
  onModalClose: () => void,
  project: Project,
  inviteCollaborator: () => void,
};

type StateProps = {
  activeProject: ?Project,
};

type State = {
  email: ?string,
};

class CollaboratorModal extends Component {
  props: Props;
  state: State = {
    email: null,
  };
  inviteCollaboratorPromise: ?Promise<void>;

  constructor(props: Props) {
    super(props);
  }

  componentDidMount() {}

  render() {
    return (
      <div>
        <Modal.Dialog>
          <Modal.Header>
            <Modal.Title>Invite Collaborator</Modal.Title>
          </Modal.Header>
          <CollaboratorForm
            addCollaborator={this.tryAddCollaborator}
            onDidAddCollaborator={this.props.onModalClose}
            onModalClose={this.props.onModalClose}
            projectId={this.props.activeProject.id}
          />
        </Modal.Dialog>
      </div>
    );
  }

  tryAddCollaborator = (rawEmail, projectId) => {
    // DEBUG invite a bunch of random emails to test collaborator limits
    // const recurse = (i) => {
    //   if (i > 49) return;
    //   setTimeout(() => {
    //     this.props.inviteCollaborator(
    //       `e${Math.random()}@mailinator.com`,
    //       projectId
    //     );
    //     recurse(i + 1);
    //   }, 100);
    // };
    // recurse(0);
    // return;

    const validateEmail = (ce) => {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(ce);
    };
    let collabEmail = rawEmail.trim();

    if (
      collabEmail &&
      validateEmail(collabEmail) &&
      collabEmail !== this.props.user.email
    ) {
      this.props.inviteCollaborator(collabEmail, projectId);
      return true;
    }
    return false;
  };
}

const mapStateToProps = (state) => {
  return {
    activeProject: getActiveProject(state),
  };
};

export default connect(mapStateToProps, actions)(CollaboratorModal);



// WEBPACK FOOTER //
// ./src/views/user/components/modals/collaborator-modal/CollaboratorModal.js